jQuery(document).ready(function ($) {
    const ajaxUrl = cfm_vars.ajax_url;
    const nonce = cfm_vars.nonce;

    $('.cfm-buttons').each(function () {
        const container = $(this);
        const postId = container.data('post-id');
        const isLoggedIn = $('body').hasClass('logged-in');

        // Funkcia na vynútenie prekreslenia (fix pre iOS)
        function forceRepaint(element) {
            element[0].style.display = 'none';
            element[0].offsetHeight; // trigger reflow
            element[0].style.display = '';
        }

        // Okamžité prekreslenie UI pred AJAX s iOS fix
        function updateUI(button, isActive) {
            const countElement = button.find('.favorites-count');
            const currentCount = parseInt(countElement.text()) || 0;
            
            // Explicitné nastavenie štýlov namiesto len toggle class
            if (isActive) {
                button.addClass('active');
                button.css({
                    'background-color': '#007bb5',
                    'color': 'white'
                });
            } else {
                button.removeClass('active');
                button.css({
                    'background-color': '#f0f4ff',
                    'color': '#007bb5'
                });
            }
            
            countElement.text(isActive ? currentCount + 1 : Math.max(0, currentCount - 1));
            
            // Vynútenie prekreslenia pre iOS
            requestAnimationFrame(() => {
                forceRepaint(button);
            });
        }

        async function loadFavoritesData() {
            try {
                // Pre neprihlásených používateľov načítame len počty bez nonce
                const data = {
                    action: 'cfm_get_favorites_count',
                    post_id: postId,
                };
                
                // Pridáme nonce len ak je používateľ prihlásený
                if (isLoggedIn && cfm_vars.nonce) {
                    data.nonce = cfm_vars.nonce;
                }
                
                const countResponse = await $.post(ajaxUrl, data);

                if (countResponse.success) {
                    container.find('.favorites-count').text('0');
                    
                    countResponse.data.forEach((item) => {
                        container.find(`[data-category="${item.category}"] .favorites-count`)
                            .text(item.user_count || '0');
                    });
                }

                // Načítame aktívne stavy len pre prihlásených používateľov
                if (isLoggedIn && cfm_vars.nonce) {
                    const statusResponse = await $.post(ajaxUrl, {
                        action: 'cfm_get_status',
                        nonce: cfm_vars.nonce,
                        post_id: postId,
                    });

                    if (statusResponse.success) {
                        // Resetovanie všetkých tlačidiel
                        container.find('.cfm-btn').each(function() {
                            const btn = $(this);
                            btn.removeClass('active');
                            btn.css({
                                'background-color': '#f0f4ff',
                                'color': '#007bb5'
                            });
                        });
                        
                        // Nastavenie aktívnych tlačidiel
                        statusResponse.data.forEach((category) => {
                            const activeBtn = container.find(`[data-category="${category}"]`);
                            activeBtn.addClass('active');
                            activeBtn.css({
                                'background-color': '#007bb5',
                                'color': 'white'
                            });
                        });
                        
                        // Vynútenie prekreslenia pre všetky tlačidlá
                        requestAnimationFrame(() => {
                            container.find('.cfm-btn').each(function() {
                                forceRepaint($(this));
                            });
                        });
                    }
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }

        // Event handler pre kliknutie len pre prihlásených používateľov
        if (isLoggedIn) {
            container.on('click', '.cfm-btn', function (e) {
                e.preventDefault(); // Zabránenie default správaniu
                const button = $(this);
                const category = button.data('category');
                const isCurrentlyActive = button.hasClass('active');
                
                // Okamžité prekreslenie
                updateUI(button, !isCurrentlyActive);
                
                $.post(ajaxUrl, {
                    action: 'cfm_toggle_favorite',
                    nonce: nonce,
                    post_id: postId,
                    category: category,
                }).done(function(response) {
                    if (!response.success) {
                        // Vrátiť pôvodný stav ak zlyhá
                        updateUI(button, isCurrentlyActive);
                    }
                }).fail(function() {
                    // Vrátiť pôvodný stav ak zlyhá
                    updateUI(button, isCurrentlyActive);
                });
            });
            
            // Pridanie touch eventov pre lepšiu responzivitu na iOS
            container.on('touchstart', '.cfm-btn', function() {
                $(this).addClass('touch-active');
            });
            
            container.on('touchend touchcancel', '.cfm-btn', function() {
                $(this).removeClass('touch-active');
            });
        }

        // Inicializácia
        loadFavoritesData();
    });

    // Mazanie obľúbených
    $('.cfm-saved-posts-grid').on('click', '.cfm-delete-post', function(e) {
        e.preventDefault();
        const button = $(this);
        const postContainer = button.closest('.cfm-saved-post');
        const postId = button.data('post-id');
        const category = button.data('category');
        
        if (confirm('Naozaj chcete odstrániť tento príspevok?')) {
            postContainer.fadeOut(300);
            
            $.post(ajaxUrl, {
                action: 'cfm_delete_favorite',
                nonce: nonce,
                post_id: postId,
                category: category
            }).done(function(response) {
                if (response.success) {
                    postContainer.remove();
                    if ($('.cfm-saved-posts-grid').children().length === 0) {
                        $('.cfm-saved-posts-grid').replaceWith('<p>' + cfm_vars.no_saved_posts_message + '</p>');
                    }
                } else {
                    postContainer.fadeIn(300);
                    alert('Nepodarilo sa odstrániť príspevok.');
                }
            }).fail(function() {
                postContainer.fadeIn(300);
                alert('Nastala chyba pri spracovaní požiadavky.');
            });
        }
    });
});